import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';

/**
 * Generated class for the CoBrochureConfirmSentEmailComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-brochure-confirm-sent-email',
  templateUrl: 'co-brochure-confirm-sent-email.html'
})
export class CoBrochureConfirmSentEmailComponent {

  text: string;

  constructor(public viewCtrl: ViewController) {

  }

  ngAfterViewInit() {
    setTimeout(()=>this.viewCtrl.dismiss().catch(err=>{}), 1500);
  }

}



// WEBPACK FOOTER //
// ./src/components/co-brochure-confirm-sent-email/co-brochure-confirm-sent-email.ts